import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRTL } from '../i18n';

/**
 * Hook to manage RTL (Right-to-Left) direction based on current language.
 * Updates the document's dir attribute and html lang attribute.
 */
export const useRTL = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const isCurrentRTL = isRTL(currentLang);

  useEffect(() => {
    // Update document direction
    document.documentElement.dir = isCurrentRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;

    // Add/remove RTL class for CSS targeting
    if (isCurrentRTL) {
      document.documentElement.classList.add('rtl');
      document.body.classList.add('rtl');
    } else {
      document.documentElement.classList.remove('rtl');
      document.body.classList.remove('rtl');
    }
  }, [currentLang, isCurrentRTL]);

  return { isRTL: isCurrentRTL, direction: isCurrentRTL ? 'rtl' : 'ltr' };
};

export default useRTL;
